import '../App.scss';
import TopBar from '../components/Organisms/TopBar.js';
import NewsItems from '../components/Organisms/NewsItems';
import CategoryButtons from '../components/Molecules/CategoryButtons';
import Button from '../components/Atoms/Button';
// import Card from '../components/Molecules/Card';
import NavBar from '../components/Molecules/NavBar';
import MediaHero from '../components/Molecules/MediaHero'
import WorksSection from '../components/Organisms/WorksSection'
import CuratedSection from  '../components/Organisms/CuratedSection'


import Kontakt from './Kontakt'

import React, { useState, Component } from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'





function App() {
  
  //
  const width = window.innerWidth;
  // The width below which the mobile view should be rendered
  const breakpoint = 577;

  return (
    <div  >
      <TopBar />
      <div className="flex">
        <Button content="NYHEDER" width="5" height="" cx="flex pos-relative br bb bold phone-w-12" rotated={true} link="filter/nyheder"/>
        <NewsItems />
        <CategoryButtons />
      </div>

      <div className="flex bb maxh-40 tablet-nomax-h phone-max-75 ">
          <MediaHero />
          {/* {width < breakpoint ? <Card cx="br bb"/> : <MediaHero />} */}
          <NavBar fullWidth={false}/>        
      </div>

      <WorksSection />

      <CuratedSection />
    <div>


    </div>



    </div>

    





  );
}

export default App;
